import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import NavNotification from "../NavNotification";
import SocialIcons from "../SocialIcons";
import ErrorBoundary from "./ErrorBoundary";
import "./Footer.scss";
import InstagramFeed from "./InstagramFeed";

const menuList = [
  {
    name: "home",
    url: "/",
  },
  {
    name: "design my wine",
    url: "/designwine",
  },
  {
    name: "winery",
    url: "/winery",
  },
  {
    name: "about us",
    url: "/about",
  },
  {
    name: "contact us",
    url: "/contact",
  },
];

const socialLinks = {
  instagram: "https://www.instagram.com",
  facebook: "https://www.facebook.com",
  twitter: "https://www.twitter.com",
  linkedin: "https://www.linkedin.com"
};

const Footer = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [notificationLink, setNotificationLink] = useState("clickiriclick");

  const location = useLocation();

  return (
    <footer>
      {showNotification && (
        <NavNotification
          setShowNotification={setShowNotification}
          notificationLink={notificationLink}
        />
      )}
      <nav className="footer-menu">
        <ul>
          {menuList.map((item) => (
            <li>
              <NavLink to={item.url}
                  onClick={(e) => {
                    if (location.pathname === "/designwine") {
                      e.preventDefault();
                      setShowNotification(true);
                      setNotificationLink(item.url);
                    }
                  }}
              >
                <h4>{item.name}</h4>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <section className="socials">
        <h3>get social</h3>
        {/* <ErrorBoundary>
          <InstagramFeed />
        </ErrorBoundary> */}
        <SocialIcons links={socialLinks} />
      </section>
      <section className="footer-info">
        <h4>Sorrisa Group</h4>
        <span>123123 Eglinton Ave. m1m2m3 Toronto, ON Canada</span>
        <span>647 1231231</span>
        <span>sorrisagroup.com</span>
        <span>info@sorrisagroup.com</span>
      </section>
    </footer>
  );
};

export default Footer;
